/**
 * Fetches data from a URL and caches it in localStorage for a specified duration.
 * @param {string} url - The API endpoint.
 * @param {string} cacheKey - The key to use in localStorage.
 * @param {number} maxAgeMs - How long to cache (in milliseconds).
 * @returns {Promise<any>} - The fetched or cached data.
 */
export async function fetchWithCache(url, cacheKey, maxAgeMs) {
  const cached = localStorage.getItem(cacheKey)
  if (cached) {
    try {
      const { timestamp, data } = JSON.parse(cached)
      if (Date.now() - timestamp < maxAgeMs) {
        return data
      }
    } catch (error) {
      console.info(error)
      // Ignore parse errors and fetch fresh
    }
  }

  const response = await fetch(url)
  if (!response.ok) throw new Error('Network response was not ok')
  const data = await response.json()
  localStorage.setItem(
    cacheKey,
    JSON.stringify({ timestamp: Date.now(), data }),
  )
  return data
}
